import React from "react";
import { Helmet } from "react-helmet-async";

import ContactHero from "../components/contact/ContactHero";
import GlobalCta from "../components/global/GlobalCta";
import FujairahTextImage from "../components/truck-rental-fujairah/FujairahTextImage";
import FujairahTextSection from "../components/truck-rental-fujairah/FujairahTextSection";
import FujairahFaq from "../components/truck-rental-fujairah/FujairahFaq";
import VanRentalTable from "../components/van-rental-dubai/VanRentalTable";

import { chillerVanRasAlKhorSections } from "../components/chiller-van-ras-al-khor/chillerVanRasAlKhorSections";
import "../components/truck-rental-fujairah/truck-rental-fujairah.css";
import "../components/van-rental-dubai/van-rental-dubai.css";
import "../components/chiller-van/chiller-van.css";

const ChillerVanForRentInRasAlKhor = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "cvr-hero":
        return (
          <ContactHero
            key={index}
            variant="chiller-van"
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "cvr-text-image":
        return (
          <FujairahTextImage
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            reverse={section.reverse}
            altBg={section.altBg}
          />
        );

      case "cvr-text-only":
        return (
          <FujairahTextSection
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "cvr-table":
        return (
          <VanRentalTable
            key={index}
            title={section.title}
            description={section.description}
            intro={section.intro}
            columns={section.columns}
            rows={section.rows}
            notes={section.notes}
            background={section.background}
          />
        );

      case "cvr-faq":
        return (
          <FujairahFaq
            key={index}
            title={section.title}
            faqs={section.faqs}
          />
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Chiller Van Rental in Ras Al Khor | From AED 250/Day</title>
        <meta name="description" content="Chiller van rental in Ras Al Khor, Dubai — pre-cooled vans on site at Industrial Area 1, at your dock in 30 to 45 minutes. 0°C to 8°C, from AED 250 a day." />
        <link rel="canonical" href="https://chillerfleet.com/chiller-van-for-rent-in-ras-al-khor" />
        <meta property="og:title" content="Chiller Van Rental in Ras Al Khor | From AED 250/Day" />
        <meta property="og:description" content="Chiller van rental in Ras Al Khor, Dubai — pre-cooled vans on site at Industrial Area 1, at your dock in 30 to 45 minutes. 0°C to 8°C, from AED 250 a day." />
        <meta property="og:url" content="https://chillerfleet.com/chiller-van-for-rent-in-ras-al-khor" />
        <meta name="twitter:title" content="Chiller Van Rental in Ras Al Khor | From AED 250/Day" />
        <meta name="twitter:description" content="Chiller van rental in Ras Al Khor, Dubai — pre-cooled vans on site at Industrial Area 1, at your dock in 30 to 45 minutes. 0°C to 8°C, from AED 250 a day." />
      </Helmet>

      {chillerVanRasAlKhorSections.map(renderSection)}
    </>
  );
};

export default ChillerVanForRentInRasAlKhor;
